<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                {{ $route.params.id ? 'Editar' : 'Adicionar' }} Unidade
              </div>
            </div>

            <div class="card-body">
              <hr />
              <br />

              <div class="row">
                <div class="col-md-12">
                  <form @submit.prevent="save">
                    <div class="form-row">
                      <div class="form-group col-md-5">
                        <label for="unitName">
                          <span class="required">*</span> Nome da Unidade:
                        </label>

                        <input
                          autocomplete="off"
                          type="text"
                          id="unitName"
                          class="form-control"
                          v-model="unit.name"
                          placeholder="Digite o nome da unidade"
                        />
                      </div>

                      <div class="form-group col-md-5">
                        <label for="companySelect">
                          <span class="required">*</span> Empresa:
                        </label>

                        <input
                          v-if="isGestorLogged"
                          type="text"
                          class="form-control"
                          :value="loggedCompanyName"
                          readonly
                        />

                        <select
                          v-else
                          id="companySelect"
                          class="form-control"
                          v-model="unit.company_id"
                        >
                          <option :value="null">Selecione uma empresa</option>
                          <option
                            v-for="company in filteredCompanies"
                            :key="company.id"
                            :value="company.id"
                          >
                            {{ company.name }}
                          </option>
                        </select>
                      </div>
                      <div class="form-group col-md-2">
                        <label>Status da Unidade</label><br>

                        <toggle-button
                          :sync="true"
                          v-model="statusToggle"
                          color="#15488A"
                          :height="25"
                        />

                        &nbsp;<b>{{ statusToggle ? "Ativo" : "Inativo" }}</b>
                      </div>
                    </div>

                    <span class="required_fields">
                      <span class="required">*</span>
                      <strong>Campos obrigatórios</strong>
                    </span>

                    <div class="block text-right">
                      <router-link to="/units" class="btn btn-back mr-1">
                        <i class="fa fa-arrow-left"></i> Voltar
                      </router-link>

                      <button type="submit" class="btn btn-add">
                        Salvar
                        <i class="fa fa-save"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "unitAdd",

  data() {
    return {
      unit: {
        name: "",
        company_id: null,
        status: 1,
      },
      companies: [],
      errors: undefined,
    };
  },

  computed: {

    loggedCompanyName() {
      if (!this.isGestorLogged) {
        return "";
      }

      const company = this.companies.find(
        (company) => Number(company.id) === Number(this.unit.company_id)
      );

      return company ? company.name : "";
    },

    loggedUser() {
      return this.$store.state.auth?.user || this.$store.state.user || null;
    },

    isAdminLogged() {
      return Number(this.loggedUser?.perfil_id) === 1;
    },

    isGestorLogged() {
      return Number(this.loggedUser?.perfil_id) === 6;
    },

    isUsuarioPadraoLogged() {
      return Number(this.loggedUser?.perfil_id) === 2;
    },

    filteredCompanies() {
        return this.companies;
    },
    
    statusToggle: {
      get() {
        return this.unit.status == 1 || this.unit.status === true;
      },
      set(value) {
        this.unit.status = value ? 1 : 0;
      },
    },
  },

  methods: {

    getLoggedUserCompany() {
      if (!this.loggedUser?.usuario_id) {
        return;
      }

      const api = this.$store.state.api + "users/" + this.loggedUser.usuario_id;

      axios
        .get(api)
        .then((response) => {
          const data = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;

          if (data && data.company_id) {
            this.unit.company_id = Number(data.company_id);
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },
    applyLoggedCompanyToUnit() {
      if (!this.isGestorLogged || !this.loggedUser?.company_id) {
        return;
      }

      this.unit.company_id = Number(this.loggedUser.company_id);
    },

    makeFormData() {
      if (this.isGestorLogged && this.unit.company_id) {
        this.unit.company_id = Number(this.unit.company_id);
      }

      let fd = new FormData();

      fd.append("name", this.unit.name);
      fd.append("company_id", this.unit.company_id || "");
      fd.append("status", this.unit.status);

      if (this.unit.id) {
        fd.append("id", this.unit.id);
        fd.append("_method", "PUT");
      } else {
        fd.append("_method", "POST");
      }

      return fd;
    },

    save() {
      let api = this.$store.state.api + "units";
      let fd = this.makeFormData();

      if (this.unit.id) {
        api += "/" + this.unit.id;
      }

      axios
        .post(api, fd)
        .then(() => {
          this.$message(
            "Sucesso",
            "Informações guardadas com sucesso",
            "success"
          );
          this.$router.push("/units");
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getUnit(id) {
      if (!id || id === "undefined") {
        return;
      }

      const api = this.$store.state.api + "units/" + id;

      axios
        .get(api)
        .then((response) => {
          const data = response.data.data;
          const unitData = Array.isArray(data) ? data[0] : data;

          if (!unitData) {
            this.$message("Erro", "Unidade não encontrada ou sem permissão", "error");
            this.$router.push("/units");
            return;
          }

          this.unit = unitData;
          this.unit.status =
            this.unit.status == 1 || this.unit.status === true ? 1 : 0;

          if (this.isGestorLogged) {
            this.applyLoggedCompanyToUnit();
          }


        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },

    getCompanies() {
      const api =
        this.$store.state.api + "companies?paginated=false&status=1";

      axios
        .get(api)
        .then((response) => {
          this.companies = response.data.data;

          // Se for gestor, usa automaticamente a única empresa que ele recebe
          if (this.isGestorLogged && this.companies.length > 0) {
            this.unit.company_id = Number(this.companies[0].id);
          }
        })
        .catch((error) => {
          this.$message(null, error.response?.data || error, "error");
        });
    },
  },

  mounted() {
    if (this.isUsuarioPadraoLogged) {
      this.$message("Erro", "Você não tem permissão para acessar esta tela", "error");
      this.$router.push("/");
      return;
    }

    this.getCompanies();
    
    if (this.isGestorLogged) {
      this.getLoggedUserCompany();
    }

    const id = this.$route.params.id;

    if (id) {
      this.getUnit(id);
    }
  },
};
</script>